import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { App } from './App';
import { Dashboard } from './views/Dashboard';
import { appRoutes, ROUTE_VALIDATION } from './routes';
import { Loading } from './components/Loading';
import { useUser } from './contexts/UserContext';
import { useOperator } from './contexts/OperatorContext';
import { PageNotFound } from './views/PageNotFound';
import { AppViewContext, useAppView } from './contexts/AppViewContext';

export function Router() {
  const operator = useOperator();
  const appView = useAppView();
  const user = useUser();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Dashboard />} />
          {appRoutes.reduce((arr: JSX.Element[], r) => {
            const route = mapRoute(r, appView, operator, user);
            if (route) arr.push(route);
            return arr;
          }, [])}
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export const mapRoute = (
  route: Route,
  view: AppViewContext,
  operator: OperatorContext,
  user: UserContext
) => {
  if (!ROUTE_VALIDATION(route, view, operator, user)) return;
  if (view.type === 'Operator' && operator.id === 0) {
    return <Route path="*" element={<Loading />} />;
  }

  if (route.subRoutes && route.subRoutes.length > 0) {
    return (
      <Route
        element={<Suspense fallback={<Loading />}>{route.component}</Suspense>}
        key={route.path}
        path={route.path}
      >
        {route.subRoutes.reduce((arr: JSX.Element[], r) => {
          const subRoute = mapRoute(r, view, operator, user);
          if (subRoute) arr.push(subRoute);
          return arr;
        }, [])}
      </Route>
    );
  }
  return (
    <Route
      element={<Suspense fallback={<Loading />}>{route.component}</Suspense>}
      key={route.path}
      path={route.path}
    />
  );
};
